module.exports = __webpack_public_path__ + "img/tarj-natura.854050c0.png";